<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="30%"
      title="人脸信息"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto">
        <el-form-item label="录入">
          <avatar-uploader
            ref="up"
            :fileSize="100"
            @getImgUrl="(v) => (form.pic = v)"
            :url="temp.pic"
          ></avatar-uploader>
        </el-form-item>
        <div>请上传正面人脸照片，图片不能大于100kb</div>
        <div>建议使用前置摄像头拍照，进入相机设置将照片质量调低</div>
        <el-link type="primary" href="https://tinypng.com/" target="_blank"
          >去压缩图片</el-link
        >
        <!-- <div @click="compressImg">压缩图片</div> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.user_id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
  import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      form: {},
      temp: {},
      addServiceDialog: false,
      admin: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  methods: {
    /**
     * @压缩公共方法
     * @return 压缩后的文件，支持两种，file和 blob
     */
    compressImg() {
      let file = this.$refs.up.getFile();
      const reader = new FileReader();
      // readAsDataURL 方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成DONE，并触发 loadend (en-US) 事件，
      // 同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
          // 图片的宽高
          let r = img.width / img.height

          const w = 200 * r;
          const h = 300 * r;
          const canvas = document.createElement("canvas");
          // canvas对图片进行裁剪，这里设置为图片的原始尺寸
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext("2d");
          // canvas中，png转jpg会变黑底，所以先给canvas铺一张白底
          ctx.fillStyle = "#fff";
          // fillRect()方法绘制一个填充了内容的矩形，这个矩形的开始点（左上点）在
          // (x, y) ，它的宽度和高度分别由width 和 height 确定，填充样式由当前的fillStyle 决定。
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          // 绘制图像
          ctx.drawImage(img, 0, 0, w, h);

          // canvas转图片达到图片压缩效果
          // 返回一个包含图片展示的 data URI base64 在指定图片格式为 image/jpeg 或 image/webp的情况下，
          // 可以从 0 到 1 的区间内选择图片的质量。如果超出取值范围，将会使用默认值 0.92。其他参数会被忽略。
          const dataUrl = canvas.toDataURL("image/jpeg", 0.5);

          let fileName = file.name + ".png";
          let blobFile = this.dataURLtoBlob(dataUrl);
          var myUrl = URL.createObjectURL(blobFile);
          this.downloadFile(myUrl, fileName);
        };
      };
    },
    downloadFile(url, name) {
      var a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      a.setAttribute("target", "_blank");
      let clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    open(info) {
      if (info && info.user_id) {
        this.temp = Object.assign({}, info);
        this.form = info;
      } else {
        this.form = this.temp = Object.assign({}, info);
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      if (!this.form.pic) {
        this.$message("请上传");
        return;
      }
      this.updateServie();
    },
    submitForm() {
      if (!this.form.pic) {
        this.$message("请上传");
        return;
      }
      this.addNew();
    },
    addNew() {
      let url = "/device/userFace/insert";
      let param = {
        user_id: "manager#" + this.admin.id,
        name: this.admin.name,
        role: "manager",
        pic: this.form.pic,
      };
      this.$axios.post(url, param).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      if (Object.keys(data).length == 0) {
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        return;
      }
      data.user_id = this.form.user_id;
      let url = "/device/userFace/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>